import { ContentType, GridData } from '@bm-js/atlascloud-shared'
import { useDroppable } from '@dnd-kit/core'
import { useContext, useMemo } from 'react'
import { DragNDropContext } from '../contexts/DragNDrop.context'
import { useDebouncedBoolean } from '../hooks/useDebounce'
import { EDITOR_DRAG_AND_DROP_TIMEOUT } from '../cnst/editor.cnst'
import { useTr } from '../utils/useTr'
import { TrKey } from '../cnst/translations/trKey.cnst'

export interface EditorDroppbleData {
  gridContent: ContentType<GridData>
  sectionIndex: number
  contentIndex: number
}

const EditorDroppable = ({
  gridContent,
  sectionIndex,
  contentIndex,
}: EditorDroppbleData) => {
  const { tr } = useTr()
  const droppableId = useMemo(() => {
    return `${gridContent.uuid}_${sectionIndex}_${contentIndex}`
  }, [gridContent, sectionIndex, contentIndex])

  const {
    state: { currentDraggingContent },
  } = useContext(DragNDropContext)

  const { isOver, setNodeRef } = useDroppable({
    id: droppableId,
    data: {
      gridContent,
      sectionIndex,
      contentIndex,
    },
  })

  const isExpanded = useDebouncedBoolean(
    !!currentDraggingContent,
    EDITOR_DRAG_AND_DROP_TIMEOUT
  )

  return (
    <div
      ref={setNodeRef}
      className={`overflow-hidden  transition-all flex justify-center items-center rounded-lg outline-dashed outline-primary-400 ${
        isExpanded ? 'h-10 my-4 outline-1' : 'h-0 outline-0'
      } ${isOver ? 'bg-primary-400/20' : 'bg-primary-400/10'}`}
    >
      <p className='text-primary-400 font-bold'>
        {isOver
          ? tr(TrKey.editorCenterDroppableHoverText)
          : tr(TrKey.editorCenterDroppableText)}
      </p>
    </div>
  )
}

export default EditorDroppable
